import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import GlobalHeader from "../../../../components/GlobalHeader.jsx";
import { fetchUserProfile, fetchUserTicketPurchases } from "../../../../utils/api/adminApi";
import "../css/ViewingCustomer.css";
import OrganizerDetailsCard from "../components/OrganizerDetailsCard.jsx";
import InstitutionDetailsCard from "../components/InstitutionDetailsCard.jsx";
import UserTicketsCard from "../components/UserTicketsCard.jsx";
import { FaInfoCircle } from "react-icons/fa";

const ViewingCustomer = () => {
  const nav = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const customerId = location.state?.userId || id;

  const [customer, setCustomer] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [formData, setFormData] = useState({
    user_id: "",
    name: "",
    title: "",
    email: "",
    cellNumber: "",
    company: "",
    vat_no: "",
    bank_name: "",
    bank_account_number: "",
    bank_account_name: "",
    paystack_subaccount_code: "",
    payout_enabled: false,
    role: "",
    is_disabled: false,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCustomer = async () => {
      try {
        if (!customerId) {
          throw new Error("No customer ID provided");
        }

        setLoading(true);
        setError(null);
        
        // Fetch customer profile
        const response = await fetchUserProfile(customerId);
        const data = response.data || response;
        if (!data) {
          throw new Error("No customer data received");
        }
        setCustomer(data);
        
        // Map customer data to formData structure (matching what cards expect)
        setFormData({
          user_id: data.user_id || data.id || customerId,
          name: data.name || "",
          title: data.title || "",
          email: data.email || "",
          cellNumber: data.cellNumber || "",
          company: data.company || "",
          vat_no: data.vat_no || "",
          bank_name: data.bank_name || "",
          bank_account_number: data.bank_account_number || "",
          bank_account_name: data.bank_account_name || "",
          paystack_subaccount_code: data.paystack_subaccount_code || "",
          payout_enabled: data.payout_enabled || false,
          role: data.role || "",
          is_disabled: data.is_disabled || false,
          created_at: data.created_at || null,
          updated_at: data.updated_at || null,
        });

        // Fetch user tickets
        try {
          const ticketsResponse = await fetchUserTicketPurchases(customerId);
          const ticketsData = ticketsResponse.data || ticketsResponse;
          setTickets(Array.isArray(ticketsData) ? ticketsData : []);
        } catch (ticketError) {
          console.error("Error fetching tickets:", ticketError);
          setTickets([]); // Set empty array if tickets fetch fails
        }
      } catch (err) {
        console.error("Error loading customer profile:", err);
        setError("Failed to load customer profile. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    loadCustomer();
  }, [customerId]);


  if (loading) {
    return (
      <div className="viewing-customer-page">
        <GlobalHeader
          title="Customer Profile"
          subtitle="View customer information"
          backTo="/users"
          logoutTo="/"
        />
        <main className="viewing-customer-main">
          <div className="viewing-customer-loading">
            <div className="viewing-customer-loading__spinner" />
            <p className="viewing-customer-loading__text">Loading customer profile...</p>
          </div>
        </main>
      </div>
    );
  }

  if (error) {
    return (
      <div className="viewing-customer-page">
        <GlobalHeader
          title="Customer Profile"
          subtitle="View customer information"
          backTo="/users"
          logoutTo="/"
        />
        <main className="viewing-customer-main">
          <div className="viewing-customer-error">
            <FaInfoCircle />
            <p className="viewing-customer-error__text">{error}</p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="viewing-customer-page">
      <GlobalHeader
        title="Customer Profile"
        subtitle="View customer information"
        backTo="/users"
        logoutTo="/"
      />
      <main className="viewing-customer-main">
        {error && (
          <div className="viewing-customer-error">
            <FaInfoCircle />
            <p className="viewing-customer-error__text">{error}</p>
          </div>
        )}

        <div className="viewing-customer-layout">
          <div className="viewing-customer-cards-grid">
            <OrganizerDetailsCard formData={formData} />
            <InstitutionDetailsCard formData={formData} />
          </div>
        </div>

        <div className="viewing-customer-tickets-section">
          <UserTicketsCard tickets={tickets} />
        </div>
      </main>
    </div>
  );
};

export default ViewingCustomer;
